<div class="flex-fill d-flex flex-column">
    <div class="btn-toolbar mx-3 mb-0 mt-3 align-items-center">
        <button *ngIf="hasChanges()" class="btn btn-primary me-2" (click)="save()">Save</button>
        <button *ngIf="hasChanges()" class="btn btn-success" (click)="cancel()">Cancel</button>
        <button *ngIf="!hasChanges()" class="btn btn-primary" (click)="close()">Close</button>
    </div>
    <div class="m-3 flex-row">
        <dx-form *ngIf="expenseReport" [formData]="expenseReport" [colCount]="3" validationGroup="expenseValidationGroup">
            <dxi-item itemType="group" caption="Expense Information">
                <dxi-item dataField="expenseDate" [label]="{ text: 'Expense Date' }"></dxi-item>
                <dxi-item dataField="created" [label]="{ text: 'Created' }" [editorOptions]="{ disabled: true }"></dxi-item>
                <dxi-item dataField="createdBy" [label]="{ text: 'Created By' }" [editorOptions]="{ disabled: true }"></dxi-item>
            </dxi-item>

            <dxi-item itemType="group" caption="Totals">
                <dxi-item dataField="_totalAmount" [label]="{ text: 'Total Amount' }" [editorOptions]="{ format: { type: 'currency', precision: 2 }, disabled: true }"></dxi-item>
            </dxi-item>

            <dxi-item itemType="group" caption="Office Information">
                <dxi-item dataField="submitted" editorType="dxDateBox" [editorOptions]="{ disabled: true }"></dxi-item>
                <dxi-item dataField="approved" editorType="dxDateBox" [editorOptions]="{ disabled: true }"></dxi-item>
                <dxi-item dataField="paid" editorType="dxDateBox" [editorOptions]="{ disabled: true }"> </dxi-item>
            </dxi-item>
        </dx-form>
    </div>
    <div class="m-3 d-flex flex-fill">
        <dx-data-grid
            class="grid-fill h-100"
            #dataGrid
            keyExpr="id"
            [dataSource]="lines"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onCellDblClick)="onRowDoubleClick($event)"
        >
            <dxi-column dataField="description"></dxi-column>
            <dxi-column dataField="notes"></dxi-column>
            <dxi-column dataField="expenseDate"></dxi-column>
            <dxi-column dataField="amount"></dxi-column>
            <dxi-column caption="Attachments" cellTemplate="attachmentTemplate"></dxi-column>
            <dxi-column></dxi-column>

            <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations>
            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>

            <div *dxTemplate="let cell of 'attachmentTemplate'">
                <ion-item-group *ngIf="cell.data.photos" class="ion-padding">
                    <ion-row class="picture-group">
                        <div *ngFor="let photo of cell.data.photos">
                            <ion-card-header>
                                <ion-thumbnail>
                                    <img src="{{ photo?.fileName }}" />
                                </ion-thumbnail>
                            </ion-card-header>
                        </div>
                    </ion-row>
                </ion-item-group>
            </div>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button (click)="openLine()" class="btn btn-sm btn-secondary">New</button>
                <button
                    class="btn btn-sm btn-secondary ms-2"
                    (click)="openLine(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Open
                </button>
                <button
                    class="btn btn-sm btn-danger ms-2"
                    (click)="deleteLine(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Delete
                </button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'"></div>
        </dx-data-grid>
    </div>
</div>
